import { createRoot } from 'react-dom/client';

import { appShell } from '@savgroup-front-common/core/helpers/appShell';
import { enableSessionCookieMode } from '@savgroup-front-common/core/services/sessionCookieMode';
import { generateUserManager } from '@savgroup-front-common/core/services/userManager';
import '@savgroup-front-common/primitive/globals.css';

import { setStoreAndHistory } from '@/view/app/App.config';

import '../datadog.config';

import AuthConfig from './configuration/auth/Auth.config';
import { getIsBffFeatureEnabled } from './helpers/getIsBffFeatureEnabled';
import './helpers/localMoment';
import App from './view/app/App';
import './view/wdyr';

const isBffFeatureEnabled = getIsBffFeatureEnabled();

if (isBffFeatureEnabled) {
  enableSessionCookieMode();
}

const userManager = isBffFeatureEnabled
  ? undefined
  : generateUserManager(AuthConfig);

setStoreAndHistory();

async function startApiMocks(): Promise<void> {
  if (!import.meta.env.DEV || import.meta.env.VITE_API_MOCK !== 'true') {
    return;
  }

  const { startWorker } = await import('./mocks/startWorker');

  await startWorker();
}

startApiMocks()
  .catch((error) => {
    // eslint-disable-next-line no-console
    console.warn(
      '[msw] api mocks failed to start, the app is rendered without mocks.',
      error,
    );
  })
  .then(() =>
    appShell({
      userManager,
      render: () => {
        const container = document.getElementById('root');

        if (!container) {
          throw new Error(
            'Root container "#root" was not found in the document',
          );
        }

        const root = createRoot(container);

        root.render(<App />);
      },
    }),
  );
